import React from "react";
import { Navigate } from "react-router-dom";

/** Page media merged into Site content as a tab; keep old URL bookmarkable. */
export default function AdminSiteImages() {
  return <Navigate to="/admin/site-content?tab=page-media" replace />;
}
